import { useState, useContext } from 'react';
import { Award } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditProgramService from '../../../../../../../services/audit_services/auditProgramService';

export default function AchieveProgramModal({ isOpen, onClose, programId, programTitle, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleAchieve = async () => {
    setLoading(true);
    
    try {
      const result = await auditProgramService.achieveAuditProgram(authTokens.access, programId);
      
      if (result.success) {
        showSuccess('Programme d\'audit marqué comme archivé avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de l\'archivage du programme d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error achieving audit program:', error);
      showError('Erreur lors de l\'archivage du programme d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleAchieve}
      title="Archiver le programme d'audit"
      message={`Êtes-vous sûr de vouloir marquer le programme d'audit "${programTitle}" comme archivé ? Cela clôturera également tous les plans d'audit de ce programme qui ne sont pas déjà clôturés ou archivés.`}
      confirmText={loading ? 'Archivage...' : 'Marquer comme archivé'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<Award className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}